export enum RevenueRecognitionType {
  Close = 'Close',
  Trailer = 'Trailer',
  TrailerLimited = 'Trailer Limited',
}

export enum RevenuePeriodType {
  Annual = 'Annual',
  Close = 'Close',
  Monthly = 'Monthly',
  Quarter = 'Quarter',
}

// todo: figure out what these should be
export enum RevenueFnName {
  SampleFn1 = 'SampleFn1',
  SampleFn2 = 'SampleFn2',
  SampleFn3 = 'SampleFn3',
}
